import React from 'react';
import {Route} from 'react-router-dom';
import DefaultBusinessLayout from '../../../../components/layout/DefaultBusinessLayout';
import AsyncPage from './async';

export default [
  <Route
    key="/business/partners"
    element={
      <DefaultBusinessLayout
        breadcrumb={[
          {
            position: 1,
            name: 'Home',
            item: '/',
          },
          {
            position: 2,
            name: 'Business',
            item: '/business',
          },
          {
            position: 3,
            name: 'Partners',
            item: '/business/partners',
          },
        ]}
        showContactSales={false}
      />
    }
  >
    <Route path="business/partners" element={<AsyncPage />} />
  </Route>,
];
